var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{attrs:{"unread-count":_vm.pushUnreadCount},on:{"open-notifications":_vm.openPushInbox}},[_c('template',{slot:"links"},[_c('li',{staticClass:"sidebar-highlight"},_vm._l((_vm.defaultTopBarItens),function(item,index){return _c('button',{key:item.function || index,class:_vm.sidebarHighlightItemClass(item),attrs:{"type":"button","title":item.name},on:{"click":function($event){return _vm.runHighlightAction(item)}}},[_c('i',{class:item.icon,attrs:{"aria-hidden":"true"}}),(item.function === 'showExpressModal')?_c('span',{staticClass:"sidebar-nova-reserva__label"},[_vm._v(_vm._s(item.name))]):_vm._e()])}),0),(
          _vm.$store.state.auth.params.User &&
          _vm.$store.state.auth.params.User != undefined &&
          Object.keys(_vm.sideBarItens).length > 1
        )?_c('sidebar-item',{attrs:{"link":_vm.homeMenu}}):_vm._e(),_vm._l((_vm.sideBarItens),function(role,index){return _c('div',{key:index},[(
            role.controller.indexOf('report') < 0 &&
            role.action.indexOf('admin') < 0 &&
            ((_vm.$store.state.auth.params.User &&
              _vm.$store.state.auth.params.User.indexpage !=
                `${role.controller}/${role.action}`) ||
              Object.keys(_vm.sideBarItens).length == 1)
          )?_c('sidebar-item',{key:index,attrs:{"link":{
            name: role.name,
            path: `/${role.controller}/${role.action}`,
            icon: _vm.menuIconClasses(
              role.icon || _vm.getRoleIcon(role),
              _vm.$route.path == '/' + role.controller + '/' + role.action
            ),
          }}}):_vm._e()],1)}),(
          _vm.sideBarItens.filter(
            (role) => role.controller.indexOf('report') >= 0
          ).length > 0
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Relatórios',
          icon: 'text-white ni ni-chart-bar-32',
        }}},_vm._l((_vm.sideBarItens.filter(
            (role) => role.controller.indexOf('report') >= 0
          )),function(role,index){return _c('sidebar-item',{key:index,attrs:{"link":{
            name: '⯈ ' + role.name,
            path: `/${role.controller}/${role.action}`,
          }}})}),1):_vm._e(),(
          _vm.sideBarItens.filter((role) => role.action.indexOf('admin') >= 0)
            .length > 0
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Administrativo',
          icon: 'text-white fa fa-users',
        }}},_vm._l((_vm.sideBarItens.filter(
            (role) => role.action.indexOf('admin') >= 0
          )),function(role,index){return _c('sidebar-item',{key:index,attrs:{"link":{
            name: '⯈ ' + role.name,
            path: `/${role.controller}/${role.action}`,
          }}})}),1):_vm._e(),_c('span',{staticClass:"w-100 d-block",staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openPushInbox.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-bell text-white",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"nav-link-text"},[_vm._v("\n            Notificações\n            "),(_vm.pushUnreadCount > 0)?_c('span',{staticClass:"badge badge-danger badge-pill ml-1"},[_vm._v(_vm._s(_vm.pushUnreadBadge))]):_vm._e()])])]),_c('sidebar-item',{attrs:{"link":{
          name: 'Configurações',
          icon: 'fa fa-cog text-white',
          path: '/configurations/index',
        }}}),_c('span',{staticClass:"w-100 d-block",staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"nav-link h-widget-trigger",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"no no-c-question-3 text-white circle",staticStyle:{"font-size":"22px"}}),_c('span',{staticClass:"nav-link-text"},[_vm._v("Ajuda")])])]),_c('a',{staticClass:"nav-link",attrs:{"href":"/logout"}},[_c('i',[_c('span',{attrs:{"aria-hidden":"true"}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5","stroke":"#FFF","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.3334 14.1673L17.5 10.0007L13.3334 5.83398","stroke":"#FFF","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.5 10H7.5","stroke":"#FFF","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}})])])]),_c('span',{staticClass:"nav-link-text"},[_vm._v("Sair")])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideTemplateSidebarItens),expression:"!hideTemplateSidebarItens"}]},[_c('hr',{staticClass:"my-3"}),_c('b-nav-item',{staticClass:"nav-item"},[_c('h6',{staticClass:"navbar-heading text-white p-0"},[_vm._v("MENU COMPLETO DEV")])]),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Início',
            icon: 'no no-c-info text-white',
            path: '/dashboard/index',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Atrativos',
            icon: 'no no-c-info text-white',
            path: '/products',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Condutores',
            icon: 'no no-c-info text-white',
            path: '/agents/index',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Clientes',
            path: '/clients',
            icon: 'no no-c-info text-white',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Op. Calendário',
            icon: 'no no-c-info text-white',
            path: '/operation/index',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Op. Reservas',
            icon: 'no no-c-info text-white',
            path: '/operation/booking-list',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Dev: Trafx',
            path: '/trafx',
            icon: 'no no-c-info text-white',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Dev: Requerimentos',
            path: '/issues',
            icon: 'no no-c-info text-white',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Monitor de Serviços',
            path: '/clients/services',
            icon: 'no no-c-info text-white',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Financeiro',
            icon: 'no no-c-info text-white',
            path: '/financial/index',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Nota Fiscal',
            path: '/nf',
            icon: 'no no-c-info text-white',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Relatórios',
            icon: 'no no-c-info text-white',
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: vendas',
              path: '/reports/sales',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: visitação',
              path: '/reports/visits',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: seguro',
              path: '/reports/booking',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: NPS',
              path: '/reports/nps',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: Repasses',
              path: '/reports/withdraw',
            }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Administrativo',
            icon: 'no no-c-info text-white',
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: Usuários',
              path: '/users/index',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: Perfis',
              path: '/roles/index',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: Permissões',
              path: '/permissions/index',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: Mensageria',
              path: '/mensageria/admin',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: Repasses',
              path: '/reports/withdraw',
            }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Configurações',
            icon: 'no no-c-info text-white',
            path: '/configurations/index',
          }}}),_c('hr',{staticClass:"my-3"}),_c('b-nav-item',{staticClass:"nav-item"},[_c('h6',{staticClass:"navbar-heading text-white p-0"},[_vm._v("ACESSO RÁPIDO")])]),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Reserva expressa',
            icon: 'no no-c-info text-white',
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: '⯈ Todas as reservas',
              path: '/public-bookings',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: Lençóis',
              path: '/booking/?eyJwbGFjZV91dWlkIjoiNTY2MkM4OTQtQUJBRS0xMUVDLThCRjYtRjIzQzkyMjdFQzhEIiwiJnVzZXJfdXVpZCI6IjM5NUVFQ0M3LTM4NDctMTFFRC04QUI1LUYyM0M5MjI3RUM4RCJ9',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ DEV: Buracão',
              path: '/booking/?eyJwbGFjZV91dWlkIjoiMkYyNDkwNTYtQTc3OC0xMUVCLTk3MDItNTI1NDAwNkNDMzA5IiwiJnVzZXJfdXVpZCI6IkVEMTUwRTc2LTRCMzEtMTFFRC04NTM0LUYyM0M5MjI3RUM4RCJ9',
            }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: 'DEV: Exemplos do template',
            icon: 'no no-c-info text-white',
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: '⯈ Components',
            }}},[_c('sidebar-item',{attrs:{"link":{
                name: 'Buttons',
                path: '/components/buttons',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Cards',
                path: '/components/cards',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Grid System',
                path: '/components/grid-system',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Notifications',
                path: '/components/notifications',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Icons',
                path: '/components/icons',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Typography',
                path: '/components/typography',
              }}})],1),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ Dashboard',
            }}},[_c('sidebar-item',{attrs:{"link":{
                name: 'Dashboard template',
                path: '/template/dashboard',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Alternative',
                path: '/template/alternative',
              }}})],1),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ Pages',
            }}},[_c('sidebar-item',{attrs:{"link":{
                name: 'User Profile',
                path: '/pages/user',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Timeline',
                path: '/pages/timeline',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Home (landing)',
                path: '/pages/home',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Pricing',
                path: '/pages/pricing',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Lock',
                path: '/pages/lock',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Register',
                path: '/pages/register',
              }}})],1),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ Starter',
              path: '/template/starter',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ Widgets / Charts / Calendar',
            }}},[_c('sidebar-item',{attrs:{"link":{
                name: 'Widgets',
                path: '/template/widgets',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Charts',
                path: '/template/charts',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Calendar',
                path: '/template/calendar',
              }}})],1),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ Forms',
            }}},[_c('sidebar-item',{attrs:{"link":{
                name: 'Elements',
                path: '/forms/elements',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Components',
                path: '/forms/components',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Validation',
                path: '/forms/validation',
              }}})],1),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ Tables',
            }}},[_c('sidebar-item',{attrs:{"link":{
                name: 'Regular',
                path: '/tables/regular',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Sortable',
                path: '/tables/sortable',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Paginated',
                path: '/tables/paginated',
              }}})],1),_c('sidebar-item',{attrs:{"link":{
              name: '⯈ Maps',
            }}},[_c('sidebar-item',{attrs:{"link":{
                name: 'Google',
                path: '/maps/google',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Vector',
                path: '/maps/vector',
              }}})],1)],1)],1)],2),_c('template',{slot:"links-after"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideTemplateSidebarItens),expression:"!hideTemplateSidebarItens"}]},[_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"navbar-heading p-0 text-white"},[_vm._v("Documentation")]),_c('b-nav',{staticClass:"navbar-nav mb-md-3",staticStyle:{"padding-bottom":"60px"}},[_c('b-nav-item',{attrs:{"href":"https://www.creative-tim.com/learning-lab/bootstrap-vue/quick-start/argon-dashboard"}},[_c('i',{staticClass:"ni ni-spaceship"}),_c('b-nav-text',{staticClass:"p-0"},[_vm._v("Getting started")])],1),_c('b-nav-item',{attrs:{"href":"https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard"}},[_c('i',{staticClass:"ni ni-palette"}),_c('b-nav-text',{staticClass:"p-0"},[_vm._v("Foundation")])],1),_c('b-nav-item',{attrs:{"href":"https://www.creative-tim.com/learning-lab/bootstrap-vue/avatar/argon-dashboard"}},[_c('i',{staticClass:"ni ni-ui-04"}),_c('b-nav-text',{staticClass:"p-0"},[_vm._v("Components")])],1),_c('b-nav-item',{attrs:{"href":"https://www.creative-tim.com/learning-lab/bootstrap-vue/charts/argon-dashboard"}},[_c('i',{staticClass:"ni ni-chart-pie-35"}),_c('b-nav-text',{staticClass:"p-0"},[_vm._v("Plugins")])],1)],1)],1)])],2),_c('div',{staticClass:"main-content"},[(false)?_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}):_vm._e(),_c('div',{staticClass:"sidenav-mobile-toggle d-xl-none",on:{"click":function($event){return _vm.$sidebar.displaySidebar(true)}}},[_vm._m(0)]),_c('div',{staticClass:"pb-5",staticStyle:{"min-height":"calc(100vh - 30px)"},on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[(_vm.isMobile)?_c('div',{staticClass:"sidenav-mobile-obscurator"},[_vm._v(" ")]):_vm._e(),_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),_c('content-footer')],1),_c('help-side-bar',{attrs:{"loadingInfos":_vm.loadinfHelpInfo,"info":_vm.sideBarInfos,"showHelpSideBar":_vm.showHelpSideBar},on:{"help-info-dismiss":function($event){_vm.showHelpSideBar = false}}}),_c('push-inbox-panel',{attrs:{"open":_vm.showPushInbox,"items":_vm.pushInboxItems,"loading":_vm.pushInboxLoading},on:{"close":function($event){_vm.showPushInbox = false},"marked-read":_vm.onPushMarkedRead,"marked-unread":_vm.onPushMarkedUnread}}),(_vm.showReservaExpressaModal)?_c('b-modal',{attrs:{"hide-footer":true,"hide-header":false,"size":"lg","no-enforce-focus":""},scopedSlots:_vm._u([{key:"modal-header",fn:function(){return [_c('div',{staticClass:"w-100 d-inline-block text-left"},[_c('h4',{staticClass:"w-100 d-inline-block modal-title"},[_vm._v("\n          Criar nova reserva\n          "),_c('button',{staticClass:"close d-inline",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeReservaExpressaModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('span',{staticClass:"w-100 text-muted d-inline-block"},[_vm._v("Selecione um atrativo para registrar uma nova reserva")])])]},proxy:true}],null,false,758198353),model:{value:(_vm.showReservaExpressaModal),callback:function ($$v) {_vm.showReservaExpressaModal=$$v},expression:"showReservaExpressaModal"}},[_c('public-bookings',{attrs:{"hide-header":"","embedded":"","placeUuid":_vm.place.uuid},on:{"close-public-bookings-modal":_vm.closeReservaExpressaModal}})],1):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidenav-toggler-inner"},[_c('i',{staticClass:"sidenav-toggler-line"}),_c('i',{staticClass:"sidenav-toggler-line"}),_c('i',{staticClass:"sidenav-toggler-line"})])
}]

export { render, staticRenderFns }